import { Map as ImmutableMap } from 'immutable';
export const generateActionCardPropsById = ({
  originalFlowActionIds = [],
  generatedActionIds = []
}) => {
  let actionCardPropsByIdWithStyling = ImmutableMap([]);

  // Disable all actions that are from the original flow
  originalFlowActionIds.forEach(actionId => {
    actionCardPropsByIdWithStyling = actionCardPropsByIdWithStyling.set(actionId, Object.assign({}, actionCardPropsByIdWithStyling.get(actionId), {
      disabled: true
    }));
  });

  // Set highlighted to true for the generated actions
  generatedActionIds.forEach(actionId => {
    actionCardPropsByIdWithStyling = actionCardPropsByIdWithStyling.set(actionId, Object.assign({}, actionCardPropsByIdWithStyling.get(actionId), {
      borderStyle: 'success'
    }));
  });
  return actionCardPropsByIdWithStyling;
};